'use strict';

Fotobook.editor.fold = {
    FOLD_ORIENTATION_HORIZONTAL: 2,
    FOLD_ORIENTATION_VERTICAL: 1,
    FOLD_OFFSET_DELIMITER: ',',
    FOLD_WIDTH: 2, // fold width in px

    _foldTemplate: [
        '<hr class="page-fold {orientationClass} drag-align-lines" data-position="{positionType}" style="',
        '    {offsetRule}: {offset}%;',
        '"/>',
    ].join(''),

    draw() {
        if (!Fotobook.book.product.fold_orientation || Fotobook.store.state.OnlineEditor.previewMode) {
            return;
        }

        $('.page-fold').remove();

        const vertical = Fotobook.book.product.fold_orientation === this.FOLD_ORIENTATION_VERTICAL;

        const html = this.getFoldsOffsets().map((offsetValue) => {
            return this._foldTemplate.supplant({
                offset: parseFloat(offsetValue),
                offsetRule: vertical ? 'left' : 'top',
                orientationClass: vertical ? 'vertical' : 'horizontal',
                positionType: vertical ? 'vertical' : 'horizontal',
            });
        });
        $(Fotobook.book.book).prepend(html.join(''));
    },

    /** Смещения сгибов */
    getFoldsOffsets() {
        let foldsOffsets = Fotobook.book.product.fold_offset.split(this.FOLD_OFFSET_DELIMITER);
        const staticFolds = parseInt(Fotobook.book.product.fold_uniform, 10);
        let rotateDeg = Fotobook.book.product.fold_orientation === this.FOLD_ORIENTATION_VERTICAL ? 90 : 0;

        if (staticFolds) {
            foldsOffsets = [];
            let offset = parseFloat((100 / (staticFolds + 1)).toFixed(2));
            let offsetValue = offset;
            for (let i = 1; i <= staticFolds; i++) {
                foldsOffsets.push(offsetValue);
                offsetValue += offset;
            }
        }

        // отразить зеркально для второй страницы
        if (Fotobook.store.getters['OnlineEditor/currentPage'] && rotateDeg) {
            foldsOffsets = foldsOffsets.map((offsetValue) => {
                return 100 - parseInt(offsetValue, 10);
            });
        }

        return foldsOffsets;
    },
};

$(document)
    .on(Fotobook.events.EDITOR_RESIZE, () => Fotobook.editor.fold.draw())
    .on(Fotobook.events.CHANGE_PAGE, () => Fotobook.editor.fold.draw());
